import { VariableType } from 'json-to-graphql-query';
export const PointContainerVariables = { name: 'String!', partnerId: 'Int' };
export const PointContainerArgs = { name: new VariableType('name'), partnerId: new VariableType('partnerId') };
//# sourceMappingURL=pointContainer.js.map